import React from 'react'
import { FormikProps } from 'formik'
import { toast } from 'react-toastify'
import { Failure } from 'lib/ui/components/Toast/components/Failure'
import { useBraintree } from 'lib/core/hooks'
import {
  useCheckout,
  usePaymentMethod,
  CreditCardForm,
  CreditCardData,
  CreditCardFormValues
} from 'lib/modules/checkout'

import { Container } from './styled'

let values: CreditCardData
let formik: FormikProps<CreditCardFormValues>
let billingAddressDataWorkaround: {
  postalCode: string
  streetAddress: string
  countryCodeAlpha2: string
}

export const Braintree = () => {
  const { checkoutSchema } = useCheckout()
  const { authorizeCard } = useBraintree()
  const billingAddressData = {
    postalCode: checkoutSchema?.billingAddress?.postalCode ?? '',
    streetAddress: checkoutSchema?.billingAddress?.street ?? '',
    countryCodeAlpha2: checkoutSchema?.billingAddress?.countryCode ?? ''
  }

  billingAddressDataWorkaround = {
    ...billingAddressData
  }

  usePaymentMethod(({ placeOrder }) => {
    formik.handleSubmit()
    formik.validateForm().then((errors) => {
      const hasErrors = !!Object.keys(errors).length
      if (!hasErrors) {
        const authorizeCardParams = {
          creditCardData: values,
          billingAddressData: billingAddressDataWorkaround
        }
        authorizeCard(authorizeCardParams).then((nonce?: string) => {
          placeOrder({
            additionalData: {
              payment_method_nonce: nonce
            }
          })
        }).catch((e) => {
          toast(() => (
            <Failure
              messageId='checkout.braintree.invalidCreditCard'
            />
          ), {
            autoClose: 15000
          })
        })
      }
    })
  })

  function handleChange (formValues: CreditCardData, formikObject: FormikProps<CreditCardFormValues>) {
    values = formValues
    formik = formikObject
  }

  return (
    <Container>
      <CreditCardForm
        onChange={handleChange}
      />
    </Container>
  )
}
